export const useSxStyles = () => {
  return {
    table: {
      borderCollapse: 'collapse',
      cellSpacing: '0px',
      '& thead': {
        '& th': {
          padding: 0,
          textAlign: 'left',
          fontSize: '13px',
          fontWeight: 'bold',
        },
      },
      '& tbody': {
        '& td': {
          textAlign: 'left',
          fontSize: '13px',
          padding: '0px',
        },
      },
    },
    thEmoji: {
      width: '30px',
      minWidth: '30px',
    },
    thDevArea: {
      width: '170px',
      minWidth: '170px',
      textAlign: 'left',
      fontSize: '13px',
      fontWeight: 'bold',
    },
    thDevAction: {
      width: '250px',
      minWidth: '250px',
      textAlign: 'left',
      fontSize: '13px',
      fontWeight: 'bold',
    },
    thMethod: {
      width: '150px',
      minWidth: '150px',
      textAlign: 'left',
      fontSize: '13px',
      fontWeight: 'bold',
    },
    thGoal: {
      width: '150px',
      minWidth: '150px',
      textAlign: 'left',
      fontSize: '13px',
      fontWeight: 'bold',
    },
    thEndDate: {
      width: '100px',
      minWidth: '100px',
      textAlign: 'left',
      fontSize: '13px',
      fontWeight: 'bold',
    },
    thInfo: {
      width: '268px',
      minWidth: '268px',
      textAlign: 'left',
      fontSize: '13px',
      fontWeight: 'bold',
    },
    td: {
      textAlign: 'left',
      fontSize: '13px',
    },
    smile: {
      color: '#92D050',
    },
    meh: {
      color: '#FFD200',
    },
    frown: {
      color: '#FF3300',
    },
  };
};
